import { FC } from 'react';
import { FormFieldStyled } from './FormField.styles';
import { FormFieldProps } from './FormField.types';

const FormField: FC<FormFieldProps> = (props) => {
  const { children, ...formFieldProps } = props;
  return <FormFieldStyled {...formFieldProps}>{children}</FormFieldStyled>;
};

export default FormField;
